import { EMAIL_DONATION_FEATURE } from '../../helpers/FeatureFlagName';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isEmailDonationSupported(): boolean {
    return isFeatureEnabled(EMAIL_DONATION_FEATURE);
}
